export const getAppStatus = state => state.app
